<template>
	<modal
		:max-width="530"
		:exibir="exibir"
		:titulo="tituloModal"
		@close="fecharModal"
		:custom-actions="false"
		:acao-cancelar="fecharModal"
		:acao-confirmar="salvarFiscal"
		:is-confirmar-visivel="true"
		nome-botao-confirmar="Salvar"
	>
		<template #body>
			<v-form v-model="isFormValid" ref="formAdicionarFiscal" lazy-validation>
				<v-row>
					<v-col cols="12" sm="12" class="mt-6">
						<label-personalizado nome-campo="Órgão" obrigatorio-por-padrao></label-personalizado>
						<v-autocomplete
							id="combo-autocomplete-ata"
							v-model="orgao"
							v-validate="'required'"
							name="órgão"
							:error-messages="errors.collect('órgão')"
							dense
							clearable
							:items="orgaosDataSource"
							placeholder="Selecione o órgão"
							class="pt-0"
							item-value="idOrgao"
							item-text="siglaDescricao"
							:filter="orgaoFilter"
							:search-input.sync="campoSelecionarOrgao"
							@update:search-input.capture="buscarOrgaos"
							return-object
							v-if="!isEditar"
						>
							<template #item="{ item, attrs, on }">
								<v-list-item v-bind="attrs" v-on="on">
									<v-list-item-content>
										<texto-tooltip
											:tamanho-maximo="49"
											:texto="item.siglaDescricao"
										></texto-tooltip>
									</v-list-item-content>
								</v-list-item>
							</template>
						</v-autocomplete>
						<texto-tooltip
							:texto="siglaDescricaoOrgao"
							:tamanho-maximo="200"
							v-if="isEditar"
							class="mt-2"
						></texto-tooltip>
					</v-col>
				</v-row>

				<v-row>
					<v-col cols="12" sm="12">
						<label-personalizado nome-campo="Nome" obrigatorio-por-padrao></label-personalizado>
						<v-autocomplete
							id="modal-adicionar-fiscal-nome"
							v-model="idUsuario"
							:items="usuariosDataSource"
							v-validate="'required'"
							name="nome"
							:error-messages="errors.collect('nome')"
							placeholder="Selecione"
							class="ma-0 py-0 pt-3 mt-1"
							item-value="id"
							item-text="nome"
							dense
							clearable
							:disabled="desabilitarCampoNome"
							v-if="!isEditar"
						>
						</v-autocomplete>
						<texto-tooltip
							:texto="nomeFiscal"
							:tamanho-maximo="200"
							v-if="isEditar"
							class="mt-2"
						></texto-tooltip>
					</v-col>
				</v-row>

				<v-row>
					<v-col cols="12" sm="6">
						<label-personalizado
							nome-campo="Início Validade"
							class="az-date-label"
							obrigatorio-por-padrao
						></label-personalizado>
						<az-date
							v-model="inicioValidade"
							name-date="início validade"
							dense
							is-required
							min-date="01/01/1920"
							class="az-date pt-0"
						></az-date>
					</v-col>
					<v-col cols="12" sm="6">
						<label-personalizado
							nome-campo="Fim Validade"
							class="az-date-label"
							obrigatorio-por-padrao
						></label-personalizado>
						<az-date
							v-model="fimValidade"
							name-date="fim validade"
							dense
							is-required
							min-date="01/01/1920"
							class="az-date pt-0"
						></az-date>
					</v-col>
				</v-row>

				<v-row>
					<v-col cols="12" md="12">
						<label-personalizado
							nome-campo="Arquivo"
							:apresentaTooltip="true"
							:mensagemPadraoTooltip="`Você pode adicionar arquivos com as extensões: ${LABEL_EXTENSOES.join(
								', ',
							)}`"
						></label-personalizado>
						<campo-arquivo-novo
							id="modal-adiconar-fiscal-campo-arquivo"
							name="Arquivo"
							:multiplo-arquivos="true"
							:extensoes-permitidas="EXTENSOES_ARQUIVO"
							show-selected
							height="70px"
							@input="adicionarAnexo"
							@apagar-anexo="apagarAnexo"
							:anexos-existentes="anexosExistentes"
							:errorUpload.sync="errorUpload"
						></campo-arquivo-novo>
					</v-col>
				</v-row>

				<v-row>
					<v-col cols="12">
						<label-personalizado obrigatorio-por-padrao nome-campo="Situação"></label-personalizado>
						<v-radio-group v-model="situacao" row class="ma-0 mt-1">
							<v-radio label="Ativo" value="ATIVO"></v-radio>
							<v-radio label="Inativo" value="INATIVO"></v-radio>
						</v-radio-group>
					</v-col>
				</v-row>
			</v-form>
		</template>
	</modal>
</template>
<script>
import LabelPersonalizado from '@/views/components/LabelPersonalizado'
import { actionTypes } from '@/core/constants'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import Modal from '@/views/components/Modal'
import TextoTooltip from '@/views/components/TextoTooltip'
import CampoArquivoNovo from '@/views/components/CampoArquivoNovo'

export default {
	name: 'modal-adicionar-fiscal',
	components: {
		CampoArquivoNovo,
		TextoTooltip,
		Modal,
		LabelPersonalizado,
	},
	mixins: [validacaoFormulario],
	inject: ['$validator'],
	props: {
		exibir: {
			type: Boolean,
		},
		tituloModal: {
			type: String,
			default: 'Novo Fiscal',
		},
		repositorioFlowbee: {
			type: String,
			required: true,
		},
		fiscal: {
			type: Object,
			default: () => {
				return {
					id: null,
				}
			},
			required: false,
		},
	},
	data() {
		return {
			isFormValid: false,
			idUsuario: null,
			usuariosDataSource: [],
			orgaoSelecionado: null,
			orgaosDataSource: [],
			inicioValidade: null,
			fimValidade: null,
			situacao: 'ATIVO',
			campoOrgao: null,
			desabilitarCampoNome: true,
			siglaDescricaoOrgao: null,
			nomeFiscal: null,
			EXTENSOES_ARQUIVO: [],
			LABEL_EXTENSOES: [],
			errorUpload: false,
			anexosExistentes: [],
			idsExternoAnexoFlowbee: [],
		}
	},
	computed: {
		campoSelecionarOrgao: {
			get() {
				return this.campoOrgao
			},
			set(valor) {
				this.campoOrgao = valor ? valor.trim() : null
			},
		},
		orgao: {
			get() {
				return this.orgaoSelecionado
			},
			set(orgao) {
				this.orgaoSelecionado = orgao
				this.campoOrgao = ''
			},
		},
		isEditar() {
			return this.fiscal.id !== null
		},
	},
	watch: {
		orgaoSelecionado() {
			if (this.orgaoSelecionado) {
				this.buscarUsuariosFiscais()
				return
			}
			this.idUsuario = null
			this.desabilitarCampoNome = true
		},
	},
	async created() {
		if (this.isEditar) await this.carregarDadosDoFiscalExistente()
		else await this.buscarOrgaos()

		this.carregarListaExtensoesAceitas()
	},
	beforeDestroy() {
		this.$validator.reset()
	},
	methods: {
		fecharModal() {
			this.$emit('fechar-modal')
		},
		orgaoFilter(item, queryText) {
			const textoSigla = item.siglaOrgao.toLowerCase()
			const textoNome = item.nomeOrgao.toLowerCase()
			const searchText = queryText.toLowerCase().trim()
			this.campoSelecionarOrgao = queryText
			return textoSigla.indexOf(searchText) > -1 || textoNome.indexOf(searchText) > -1
		},
		async buscarOrgaos() {
			const campoOrgao = this.orgao ? this.orgao.siglaOrgao : this.campoSelecionarOrgao?.trim()
			const orgaos = await this.$store.dispatch(actionTypes.CONFIGURACAO.FISCAIS.BUSCAR_ORGAOS, campoOrgao)
			this.orgaosDataSource = orgaos.itens
		},
		async buscarUsuariosFiscais() {
			const { usuarios } = await this.$store.dispatch(actionTypes.CONFIGURACAO.FISCAIS.BUSCAR_USUARIOS_FISCAIS, {
				idOrgao: this.orgaoSelecionado?.idOrgao,
			})
			this.usuariosDataSource = usuarios
			this.desabilitarCampoNome = false
		},
		async salvarFiscal() {
			const formValido = await this.$validator._base.validateAll()

			if (formValido) {
				if (this.isEditar) {
					this.$emit('confirmar-edicao-fiscal', {
						idFiscal: this.fiscal.id,
						body: this.montarPayloadEdicao(),
					})
				} else {
					await this.$store
						.dispatch(actionTypes.CONFIGURACAO.FISCAIS.ADICIONAR_FISCAL, this.montarPayloadCriacao())
						.then(() => {
							this.fecharModal()
							this.mostrarNotificacaoSucesso('Operação realizada com sucesso.')
						})
				}
			}
		},
		montarPayloadCriacao() {
			return {
				idOrgao: this.orgaoSelecionado?.idOrgao,
				idUsuario: this.idUsuario,
				inicioValidade: this.inicioValidade,
				fimValidade: this.fimValidade,
				situacao: this.situacao,
				idsExternoAnexoFlowbee: this.getListaCompletaDeAnexos(),
			}
		},
		montarPayloadEdicao() {
			return {
				inicioVigencia: this.inicioValidade,
				fimVigencia: this.fimValidade,
				situacao: this.situacao,
				idsExternoAnexoFlowbee: this.getListaCompletaDeAnexos(),
			}
		},
		async carregarDadosDoFiscalExistente() {
			this.siglaDescricaoOrgao = this.fiscal.siglaDescricaoOrgao
			this.nomeFiscal = this.fiscal.nomeFiscal
			this.inicioValidade = this.fiscal.inicioVigencia
			this.fimValidade = this.fiscal.fimVigencia
			this.situacao = this.fiscal.situacao
			this.anexosExistentes = await this.buscarAnexosExistentes(this.fiscal.id)
		},
		async buscarAnexosExistentes(idFiscal) {
			const anexos = await this.$store.dispatch(actionTypes.CONFIGURACAO.FISCAIS.BUSCAR_ANEXOS, { idFiscal })

			return anexos.map((an) => ({ idExterno: an.idExterno, name: an.nome }))
		},
		carregarListaExtensoesAceitas() {
			this.EXTENSOES_ARQUIVO = this.getListTextConstant(this.extensoesArquivos, 'value')
			this.LABEL_EXTENSOES = this.getListTextConstant(this.extensoesArquivos, 'text')
		},
		async apagarAnexo(posicao) {
			const totalAntigos = this.anexosExistentes.length
			const isAnexoExistente = posicao < totalAntigos

			isAnexoExistente
				? await this.apagarAnexoExistente(posicao)
				: await this.apagarAnexoNovo(posicao, totalAntigos)
		},
		async apagarAnexoExistente(posicao) {
			const itemExistente = this.anexosExistentes[posicao]

			if (itemExistente.idExterno) {
				await this.$store.dispatch(actionTypes.CONFIGURACAO.FISCAIS.EXCLUIR_ANEXO_FISCAL, {
					idFiscal: this.fiscal.id,
					idExterno: itemExistente.idExterno,
				})
			}

			this.anexosExistentes.splice(posicao, 1)

			const idxStore = this.idsExternoAnexoFlowbee.findIndex((x) => x.idExterno === itemExistente.idExterno)

			if (idxStore >= 0) this.idsExternoAnexoFlowbee.splice(idxStore, 1)
		},
		async apagarAnexoNovo(posicao, totalAntigos) {
			const idxNovo = posicao - totalAntigos
			const itemNovo = this.idsExternoAnexoFlowbee[idxNovo]

			if (itemNovo.idExterno) {
				await this.$store.dispatch(actionTypes.ARQUIVO.EXCLUIR_ARQUIVO_TEMPORARIO, itemNovo.idExterno)
			}

			this.idsExternoAnexoFlowbee.splice(idxNovo, 1)
		},
		async adicionarAnexo(anexoSelecionado) {
			await this.$store
				.dispatch(
					actionTypes.ARQUIVO.ENVIAR_ARQUIVO_TEMPORARIO,
					this.getFormArquivoTemporario(anexoSelecionado),
				)
				.then((arquivo) =>
					this.idsExternoAnexoFlowbee.push({ idExterno: arquivo.id, nome: anexoSelecionado.name }),
				)
				.catch(() => (this.errorUpload = true))
		},
		getFormArquivoTemporario(file) {
			return {
				file: file,
				repositorioFlowbee: this.repositorioFlowbee,
			}
		},
		getListaCompletaDeAnexos() {
			const anexosAntigos = this.anexosExistentes.map((an) => ({ idExterno: an.idExterno, nome: an.name }))
			const anexosNovos = this.idsExternoAnexoFlowbee

			return [...anexosAntigos, ...anexosNovos]
		},
	},
}
</script>

<style scoped lang="stylus">
.bg-white
	background-color white

.corpo-modal-selecao
	min-height 70vh
</style>
